
import { Pipe, PipeTransform } from '@angular/core';
import { ADPResourceService as ResourceService } from 'digital-core';

@Pipe({
  name: 'resourceDisplay'
})
export class ResourceDisplayPipe implements PipeTransform {
  constructor(private resourcesService: ResourceService) { }
  transform(value: any, resource: any): any {
    if (!value) {
      return "";
    }
    let regex = this.resourcesService.getViewResourceObject(resource).MaskRegex;
    if(regex == '' || regex == null){
      return value;
    }
    else{
    let options = new RegExp(regex);
    let result = value.replace(options, '');
    // console.log(result);
    return result;
    }
  }
}
